import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { OrganizationCreateForm } from "@/features/organization/OrganizationCreateForm";

export function OrganizationCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/organization",
            label: "Organization",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add Organization</H2>
      <OrganizationCreateForm />
    </>
  );
}
